import React, { useState } from 'react';
import { ChevronDown, Crosshair, MapPin, Lightbulb, Users, AlertTriangle, TrendingUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
export function QueIncluye() {
  const tomos = [{
    num: 1,
    icon: Crosshair,
    price: '$6.990',
    title: 'Técnica zurda: los golpes que ganan partidos',
    desc: 'Dominá el control, el pase, el remate y la definición con tu pierna izquierda. Mecánica completa con correcciones para cada golpe fundamental del fútbol 5.',
    resultado: 'Vas a ejecutar los golpes con confianza y precisión usando tu zurda desde el primer entrenamiento.'
  }, {
    num: 2,
    icon: MapPin,
    price: '$6.990',
    title: 'El zurdo en la cancha: posicionamiento y movimiento',
    desc: 'Aprendé dónde posicionarte en cada situación del juego como zurdo, cómo moverte sin la pelota y cómo leer el juego antes de que ocurra.',
    resultado: 'Vas a dejar de estar perdido en la cancha y empezar a aparecer siempre en el lugar correcto.'
  }, {
    num: 3,
    icon: Lightbulb,
    price: '$5.990',
    title: 'Táctica zurda: cómo usar tu izquierda como ventaja',
    desc: 'Entendé por qué el zurdo descoloca a los rivales y cómo explotarlo tácticamente en el fútbol 5. Patrones de juego, salidas y jugadas diseñadas para la pierna izquierda.',
    resultado: 'Tu zurda se convierte en un arma táctica real que tus rivales no saben cómo neutralizar.'
  }, {
    num: 4,
    icon: Users,
    price: '$5.990',
    title: 'Fútbol 5 en equipo: jugá como zurdo sin romper el sistema',
    desc: 'Cómo sincronizarte con tus compañeros siendo zurdo, cómo comunicarte tácticamente y cómo integrarte a cualquier sistema de juego sin perder tu identidad zurda.',
    resultado: 'Tus compañeros van a entender cómo jugarte y el equipo va a funcionar mejor con vos adentro.'
  }, {
    num: 5,
    icon: AlertTriangle,
    price: '$4.990',
    title: 'Los 30 errores más comunes del zurdo amateur',
    desc: 'Los errores técnicos, tácticos y mentales que frenan a todo zurdo amateur. Cada error con su causa, corrección y ejercicio específico para eliminarlo.',
    resultado: 'Vas a identificar exactamente qué te está costando puntos y partidos, y cómo corregirlo desde hoy.'
  }, {
    num: 6,
    icon: TrendingUp,
    price: '$4.040',
    title: 'Plan de mejora de 30 días: del zurdo común al zurdo temido',
    desc: 'Programa diario estructurado semana a semana con foco específico, duración y métrica de progreso para el jugador zurdo amateur.',
    resultado: 'En 30 días tu zurda va a ser tu mayor fortaleza en la cancha, no tu característica ignorada.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 bg-white relative" data-id="element-239">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-240">
        <FadeIn data-id="element-241">
          <div className="text-center mb-10" data-id="element-242">
            <span className="inline-block bg-celeste text-navy font-display font-black text-base md:text-lg tracking-widest uppercase px-5 py-2 rounded-full shadow-md mb-4" data-id="element-243">
              6 Tomos Especializados
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-black mb-4 uppercase text-navy" data-id="element-244">
              ¿Qué incluye el Pack?
            </h2>
            <p className="text-gray-600 mb-2" data-id="element-245">
              Tocá cada tomo para ver el contenido completo.
            </p>
            <p className="text-navy font-medium" data-id="element-246">
              Valor total{' '}
              <span className="line-through text-gray-400" data-id="element-247">$34.990</span> —{' '}
              <span className="text-celeste font-bold" data-id="element-248">hoy por $19.990</span>
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-249">
          {tomos.map((tomo, idx) => {
          const isOpen = openIndex === idx;
          return <FadeIn key={idx} delay={idx * 0.05} data-id="element-250">
                <div className="bg-lightbg border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-251">
                  <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus:bg-gray-50 transition-colors" data-id="element-252">
                    <div className="flex items-center gap-4 pr-4" data-id="element-253">
                      <div className="flex items-center justify-center w-12 h-12 rounded-full bg-celeste/10 text-celeste flex-shrink-0" data-id="element-254">
                        <tomo.icon className="w-6 h-6" data-id="element-255" />
                      </div>
                      <div data-id="element-256">
                        <div className="flex items-center gap-2 mb-1" data-id="element-257">
                          <span className="text-celeste font-display font-bold text-xs tracking-widest uppercase" data-id="element-258">
                            TOMO {tomo.num}
                          </span>
                          <span className="text-gray-400 text-xs font-medium" data-id="element-259">
                            {tomo.price}
                          </span>
                        </div>
                        <h3 className="font-bold text-navy text-base sm:text-lg leading-tight" data-id="element-260">
                          {tomo.title}
                        </h3>
                      </div>
                    </div>
                    <ChevronDown className={`w-5 h-5 text-celeste flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-261" />
                  </button>

                  <AnimatePresence data-id="element-262">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} data-id="element-263">
                        <div className="px-6 pb-6 pt-2" data-id="element-264">
                          <div className="border-t border-gray-200 pt-4 space-y-4" data-id="element-265">
                            <div data-id="element-266">
                              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-267">
                                <span className="font-bold text-navy" data-id="element-268">
                                  Descripción:
                                </span>{' '}
                                {tomo.desc}
                              </p>
                            </div>
                            <div className="bg-celeste/10 rounded-lg p-4 border border-celeste/20" data-id="element-269">
                              <p className="text-navy text-sm font-medium leading-relaxed" data-id="element-270">
                                <span className="font-bold text-celeste uppercase text-xs tracking-wider block mb-1" data-id="element-271">
                                  Resultado
                                </span>
                                {tomo.resultado}
                              </p>
                            </div>
                          </div>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}